import { createApp } from 'vue';
import KittComponent from '@thehotelsnetwork/kittchat/dist/kittchat.es';
import css from '@thehotelsnetwork/kittchat/dist/kittchat.styles';
import { createRootContainer, insertRootContainer } from './chunk-insert-root-container.js';
import './main.js';
import './chunk-widgets.js';
import '@thehotelsnetwork/md5';

const factory = ({ document, thn, }) => {
    const viewData = {};
    const widgetView = {
        data: viewData,
        async create(ctx) {
            if (viewData.el) {
                return;
            }
            const { bundle } = ctx;
            viewData.currentBundle = bundle;
            // DOM Element style
            const styleProps = {
                'background-color': 'transparent',
                display: 'block',
                float: 'none',
                left: '0',
                right: '0',
                margin: '0',
                padding: '0',
                border: '0',
                position: 'fixed',
                top: 0,
                visibility: 'hidden',
                'z-index': String(-1 * Number(// Init negative always
                bundle.zIndex)),
            };
            const { shadowEl, topElement, shadowRoot } = createRootContainer({ id: this.data.id, contentStyles: css.toString(), topElementStyles: styleProps }, { document });
            viewData.el = topElement;
            viewData.shadowRoot = shadowRoot;
            viewData.shadowEl = shadowEl;
            // widget must be initialized as not visible
            topElement.setAttribute('data-thn-visible', '0');
            // attach to document
            const insertArgs = document.body.lastElementChild
                ? [document.body.lastElementChild, topElement, 'IA']
                : [document.body, topElement, 'II'];
            const isRootInserted = insertRootContainer(...insertArgs);
            if (!isRootInserted) {
                const error = new Error('Failed to insert the root container in the DOM');
                this.logger.warn(ctx.debugPrefix, error.message, 'with args:', insertArgs);
                error.status = 'no-selector';
                throw error;
            }
        },
        async show(ctx) {
            if (!viewData.el || !viewData.shadowEl) {
                await widgetView.create.call(this, ctx);
            }
            if (!viewData.el || !viewData.shadowEl) {
                return;
            }
            const { bundle } = ctx;
            viewData.currentBundle = bundle;
            if (!viewData.shadowEl) {
                return;
            }
            // If already created, unmount before recreate
            if (!thn.empty(viewData.app)) {
                viewData.app.unmount();
            }
            await this.container.scheduler.yield();
            viewData.app = createApp(KittComponent, { config: bundle });
            viewData.vm = viewData.app.mount(viewData.shadowEl);
            if (viewData.el) {
                viewData.el.style.visibility = 'visible';
                viewData.el.setAttribute('data-thn-visible', '1');
                const zIndex = Number(viewData.el.style.zIndex);
                if (zIndex < 0) {
                    viewData.el.style.zIndex = String(zIndex * -1);
                }
            }
        },
        minimize() {
            try {
                viewData.vm?.collapse?.();
            }
            catch (error) {
                this.logger.warn(`Unable to call minimize function on ${this.data.name} widget`, error);
            }
        },
        destroy() {
            if (viewData.app) {
                viewData.vm?.destroy?.();
                viewData.app?.unmount();
                delete viewData.app;
                delete viewData.vm;
            }
            if (viewData.el) {
                viewData.el?.remove();
                delete viewData.el;
                delete viewData.shadowEl;
                delete viewData.shadowRoot;
            }
        },
        hide() {
            if (viewData.el) {
                viewData.el.style.visibility = 'hidden';
                viewData.el.setAttribute('data-thn-visible', '0');
                const zIndex = Number(viewData.el.style.zIndex);
                if (zIndex > 0) {
                    viewData.el.style.zIndex = String(zIndex * -1);
                }
            }
        },
    };
    return widgetView;
};

export { factory };
